// src/firebase.js

import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithCustomToken,
  updateProfile,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import axios from 'axios';

// ———————————————————————————————————————————————
// 1) Firebase web config from your .env
// ———————————————————————————————————————————————
const firebaseConfig = {
  apiKey:             process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:         process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:          process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:      process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:              process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase App & services
const app  = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db   = getFirestore(app);

// Persist auth across tabs and reloads
setPersistence(auth, browserLocalPersistence).catch(console.error);

// Debug: watch for auth state changes
onAuthStateChanged(auth, user => {
  console.log('🔑 Firebase auth state changed:', user);
});

// ———————————————————————————————————————————————
// 2) Build your backend base URL (no trailing slash)
// ———————————————————————————————————————————————
const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

// ———————————————————————————————————————————————
// 3) Helper: Exchange your FastAPI JWT for a Firebase custom token
// ———————————————————————————————————————————————
export async function signInWithBackendToken(token, displayName) {
  try {
    // Get Firebase custom token from your backend
    const response = await axios.post(
      'https://fastapi-backend-657266059621.asia-northeast1.run.app/api/auth/firebase-token',
      { token },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    const { firebaseToken } = response.data;

    // Sign in to Firebase with the custom token
    const userCredential = await signInWithCustomToken(auth, firebaseToken);

    // Update the user's display name if provided
    if (displayName) {
      await updateProfile(userCredential.user, { displayName });
    }

    return userCredential;
  } catch (error) {
    console.error('Firebase sign-in error:', error);
    throw error;
  }
}

// Export for use in your app
export { app, auth, db };
